(function () {
  'use strict';

  if (window.NavigationManager) {
    return;
  }

  if (window.vendorsReadyPromise) {
    try {
      // Delay load until vendors (jQuery, Backbone) are ready
      window.vendorsReadyPromise.then(function () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '/static/js/navigation-manager.js';
        script.onload = function () {
          if (typeof window.initializeNavigationIntegration === 'function') {
            window.initializeNavigationIntegration();
          }
          window.dispatchEvent(new CustomEvent('navigation-manager-loaded'));
        };
        script.onerror = function () {
          console.error('[NAV-LOADER] Failed to load navigation-manager.js');
        };
        document.head.appendChild(script);
      });
      return;
    } catch (e) {
      /* fallback to immediate */
    }
  }

  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '/static/js/navigation-manager.js';
  script.onload = function () {
    if (typeof window.initializeNavigationIntegration === 'function') {
      window.initializeNavigationIntegration();
    }
    window.dispatchEvent(new CustomEvent('navigation-manager-loaded'));
  };
  script.onerror = function () {
    console.error('[NAV-LOADER] Failed to load navigation-manager.js');
  };
  document.head.appendChild(script);
})();
